import React, { Component } from "react";

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";


class Compliance extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                
                <section class="header-interno padrao">
                  <div class="container">
                    <h1>Compliance</h1>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-4">
                        <a href={"../pdf/itechmed-doc-pdf.pdf"} class="d-flex justify-content-center flex-column">
                          <p class="text-center font-weight-bold">Acesse o Documento</p>
                          <img src={"../assets/img/image-pdf.png"} class="img-fluid" style={{ width: '130px', margin: '0 auto' }} alt="Imagem de um aquivo PDF"></img>
                        </a>
                      </div>
                      
                      <div class="col-12 col-lg-8">
                        <p>Para nos destacar no mercado em que atuamos, não precisamos apenas de esforços para oferecer a melhor tecnologia; Devemos também manter o mais alto padrão de ética. Estamos em conformidade com as leis e normas que regem nosso setor é a primeira e mais importante etapa, mas, além disso, espera-se que façamos a coisa certa, todos os dias.</p>

                        <p>O código de conduta da ItechMed é o pilar do nosso programa de conformidade. Ele é construído sobre nossos valores como empresa: Compromisso com o resultado, Comportamento ético e integro, Respeito e valorização das Pessoas e Conhecimento e Evolução.</p>

                        <p>Através dessas diretrizes, podemos permanecer fieis ao nosso guia de princípios entregando valor agregado aos nossos clientes, parceiros de negócios e todo o ecossistema em que atuamos.</p>

                        <p>Tão importante quanto estamos em conformidade com o Código, é todos nós sermos responsáveis por relatar imediatamente qualquer questão de conformidade legal e ética que possamos encontrar.</p>
                      </div>
                    </div>
                  </div>
                </section>
                
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Compliance;